<template>
  <div
    v-show="showNavbar"
    class="navbar__container m-navbar"
    :class="{backdrop:activeNavbar,navbar__background:generalBackground,purple__background:contactBackground}"
  >
    <img
      class="navbar__logo m-navbar"
      :src="logoVersion"
      v-if="windowWidth <= 768"
      @click="navigateTo(0)"
    >
    <transition name="fade">
      <button
        class="navbar__menu m-navbar"
        :class="{white:isWhite}"
        @click="toggleNavbar"
        v-if="!activeNavbar && windowWidth <= 768"
      >
        <font-awesome-icon icon="bars" class="m-navbar" size="2x"  />
      </button>
    </transition>
    <div class="navbar  m-navbar" id="navbar" :class="{ active: activeNavbar}">
      <div
        class="navbar__close m-navbar"
        @click="toggleNavbar"
        v-if="activeNavbar && windowWidth <= 768"
      >
        <font-awesome-icon icon="times" class="m-navbar" size="1x" />
      </div>

      <img
      class="navbar__logo m-navbar"
      :src="logoVersion"
      @click="navigateTo(0)"
    >
      <ul
        class="navbar__links m-navbar"

      >
        <!-- <li class="navbar__link" @click="navigateTo(0)">Inicio</li> -->
        <li class="navbar__link m-navbar" :class="{white:isWhite,active__section:sections.counter === 1}"  @click="navigateTo(1)">
          Trabajos
        </li>
        <li class="navbar__link m-navbar" :class="{white:isWhite,active__section:sections.counter === 2}"  @click="navigateTo(2)">Nosotros</li>
        <li class="navbar__link m-navbar" :class="{white:isWhite,active__section:sections.counter === 3}"  @click="navigateTo(3)">Equipo</li>
        <li class="navbar__link m-navbar" :class="{white:isWhite,active__section:sections.counter === 4}"  @click="navigateTo(4)">Central de ideas</li>
        <li
          class="navbar__link contacto m-navbar white"
          @click="navigateTo(5)"
        >
          Contacto
        </li>
      </ul>
      <div class="navbar__social m-navbar" :class="{white:isWhite}">
        <a
          href="https://www.instagram.com/circulo.agencia/"
          target="blank"
          class="navbar__social--link m-navbar"
          ><font-awesome-icon :icon="['fab', 'instagram']" size="lg"
        /></a>
        <a
          href="https://vimeo.com/circuloagencia"
          target="_blank"
          class="navbar__social--link m-navbar"

        >
          <font-awesome-icon :icon="['fab', 'vimeo-v']" size="lg" />
        </a>
        <a
          href="https://www.linkedin.com/company/circulo.agencia/"
          target="blank"
          class="navbar__social--link m-navbar"
          ><font-awesome-icon :icon="['fab', 'linkedin']" size="lg"
        /></a>
        <a
          href="https://www.youtube.com/@circuloagencia4030"
          target="blank"
          class="navbar__social--link m-navbar"
          ><font-awesome-icon :icon="['fab', 'youtube']" size="lg"
        /></a>
        <a
          href="https://www.behance.net/agenciacirculo"
          target="blank"
          class="navbar__social--link m-navbar"
          ><font-awesome-icon :icon="['fab', 'behance']" size="lg"
        /></a>
      </div>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/logo.svg'
import mixins from '@/mixins/mixins'

export default {
  mixins: [mixins],
  created () {
    this.$store.commit('setWindowWidth')
    this.$store.commit('setWindowHeight')
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  components: {
    logo
  },
  methods: {
    toggleNavbar () {
      this.$store.commit('toggleNavbar')
    },
    handleResize () {
      this.$store.commit('setWindowWidth')
      this.$store.commit('setWindowHeight')
      this.$store.commit('setSwitcherRect')
      if (this.windowWidth > 768) {
        this.$store.commit('closeNavbar')
      }
    },
    handleScroll () {
      this.$store.commit('setScrollY', window.scrollY)
    }
  },
  computed: {
    activeNavbar () {
      return this.$store.state.activeNavbar
    },
    routeName () {
      return this.$route.name
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    sections () {
      return this.$store.state.sections
    },
    showNavbar () {
      return this.$route.path !== '/contacto/gracias'
    },
    isWhite () {
      return (this.sections.counter === 0 || this.sections.counter === 5)
    },
    isPurple () {
      return this.sections.counter === 5
    },
    logoVersion () {
      if (this.activeNavbar) {
        return '/img/png/logo-black.png'
      } else {
        return this.isWhite ? '/img/png/logo-white.png' : '/img/png/logo-black.png'
      }
    },
    generalBackground () {
      if (!this.activeNavbar) {
        return this.sections.counter !== 0 && this.sections.counter !== 5
      }
    },
    contactBackground () {
      if (!this.activeNavbar) {
        return this.sections.counter === 5
      }
    }
  }
}
</script>
